import React from "react";
import "../Styles/Logo/logo.scss";

const Logo = () => {
  return (
    <div className="Logo">
      <h1>
        Sneakers<span className="ville">Ville</span>
      </h1>
    </div>
  );
};

export default Logo;
